function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/model/utils/selection-post-fixer
 */
import Range from '../range';
import Position from '../position';
/**
 * Injects selection post-fixer to the model.
 *
 * The role of the selection post-fixer is to ensure that the selection is in a correct place
 * after a {@link module:engine/model/model~Model#change `change()`} block was executed.
 *
 * The correct position means that:
 *
 * * All collapsed selection ranges are in a place where the {@link module:engine/model/schema~Schema}
 * allows a `$text`.
 * * None of the selection's non-collapsed ranges crosses a {@link module:engine/model/schema~Schema#isLimit limit element}
 * boundary (a range must be rooted within one limit element).
 * * Only {@link module:engine/model/schema~Schema#isSelectable selectable elements} can be selected from the outside
 * (e.g. `[<paragraph>foo</paragraph>]` is invalid). This rule applies independently to both selection ends, so this
 * selection is correct: `<paragraph>f[oo</paragraph><imageBlock></imageBlock>]`.
 *
 * If the position is not correct, the post-fixer will automatically correct it.
 *
 * ## Fixing a non-collapsed selection
 *
 * See as an example a selection that starts in a P1 element and ends inside the text of a TD element
 * (`[` and `]` are range boundaries and `(l)` denotes an element defined as `isLimit=true`):
 *
 *		root
 *		 |- element P1
 *		 |   |- "foo"                                      root
 *		 |- element TABLE (l)                   P1         TABLE             P2
 *		 |   |- element TR (l)                 f o[o     TR      TR         b a r
 *		 |   |   |- element TD (l)                       TD      TD
 *		 |   |       |- "aaa"                          a]a a    b b b
 *		 |   |- element TR (l)
 *		 |   |   |- element TD (l)                           ||
 *		 |   |       |- "bbb"                                ||
 *		 |- element P2                                       VV
 *		 |   |- "bar"
 *		                                                   root
 *		                                        P1         TABLE]            P2
 *		                                       f o[o     TR      TR         b a r
 *		                                                 TD      TD
 *		                                               a a a    b b b
 *
 * In the example above, the TABLE, TR and TD are defined as `isLimit=true` in the schema. The range which is not contained within
 * a single limit element must be expanded to select the outermost limit element. The range end is inside the text node of the TD element.
 * As the TD element is a child of the TR and TABLE elements, where both are defined as `isLimit=true` in the schema, the range must be
 * expanded to select the whole TABLE element.
 *
 * **Note** If the selection contains multiple ranges, the method returns a minimal set of ranges that are not intersecting after expanding
 * them to select `isLimit=true` elements.
 *
 * @param {module:engine/model/model~Model} model
 */

export function injectSelectionPostFixer(model) {
  model.document.registerPostFixer(function (writer) {
    return selectionPostFixer(writer, model);
  });
} // The selection post-fixer.
//
// @param {module:engine/model/writer~Writer} writer
// @param {module:engine/model/model~Model} model

function selectionPostFixer(writer, model) {
  var selection = model.document.selection;
  var schema = model.schema;
  var ranges = [];
  var wasFixed = false;

  var _iterator = _createForOfIteratorHelper(selection.getRanges()),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var modelRange = _step.value;
      // Go through all ranges in selection and try fixing each of them.
      // Those ranges might overlap but will be corrected later.
      var correctedRange = tryFixingRange(modelRange, schema); // "Selection fixing" algorithms sometimes get lost. In consequence, it may happen
      // that a new range is returned but, in fact, it has the same positions as the original
      // range anyway. If this range is not discarded, a new selection will be set and that,
      // for instance, would destroy the selection attributes. Let's make sure that the post-fixer
      // actually worked first before setting a new selection.
      //
      // https://github.com/ckeditor/ckeditor5/issues/6693

      if (correctedRange && !correctedRange.isEqual(modelRange)) {
        ranges.push(correctedRange);
        wasFixed = true;
      } else {
        ranges.push(modelRange);
      }
    } // If any of ranges were corrected update the selection.

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (wasFixed) {
    writer.setSelection(mergeIntersectingRanges(ranges), {
      backward: selection.isBackward
    });
  }
} // Tries fixing a range if it's incorrect.
//
// @param {module:engine/model/range~Range} range
// @param {module:engine/model/schema~Schema} schema
// @returns {module:engine/model/range~Range|null} Returns fixed range or null if range is valid.


function tryFixingRange(range, schema) {
  if (range.isCollapsed) {
    return tryFixingCollapsedRange(range, schema);
  }

  return tryFixingNonCollapsedRage(range, schema);
} // Tries to fix collapsed ranges.
//
// * Fixes situation when a range is in a place where $text is not allowed
//
// @param {module:engine/model/range~Range} range Collapsed range to fix.
// @param {module:engine/model/schema~Schema} schema
// @returns {module:engine/model/range~Range|null} Returns fixed range or null if range is valid.


function tryFixingCollapsedRange(range, schema) {
  var originalPosition = range.start;
  var nearestSelectionRange = schema.getNearestSelectionRange(originalPosition); // This might be null ie when editor data is empty.
  // In such cases there is no need to fix the selection range.

  if (!nearestSelectionRange) {
    return null;
  }

  if (!nearestSelectionRange.isCollapsed) {
    return nearestSelectionRange;
  }

  var fixedPosition = nearestSelectionRange.start; // Fixed position is the same as original - no need to return corrected range.

  if (originalPosition.isEqual(fixedPosition)) {
    return null;
  }

  return new Range(fixedPosition);
} // Tries to fix an expanded range.
//
// @param {module:engine/model/range~Range} range Expanded range to fix.
// @param {module:engine/model/schema~Schema} schema
// @returns {module:engine/model/range~Range|null} Returns fixed range or null if range is valid.


function tryFixingNonCollapsedRage(range, schema) {
  var start = range.start,
      end = range.end;
  var isTextAllowedOnStart = schema.checkChild(start, '$text');
  var isTextAllowedOnEnd = schema.checkChild(end, '$text');
  var startLimitElement = schema.getLimitElement(start);
  var endLimitElement = schema.getLimitElement(end); // Ranges which both end are inside the same limit element (or root) might needs only minor fix.

  if (startLimitElement === endLimitElement) {
    // Range is valid when both position allows to place a text:
    // - <block>f[oobarba]z</block>
    // This would be "fixed" by a next check but as it will be the same it's better to return null so the selection stays the same.
    if (isTextAllowedOnStart && isTextAllowedOnEnd) {
      return null;
    } // Range that is on non-limit element (or is partially) must be fixed so it is placed inside the block around $text:
    // - [<block>foo</block>]    ->    <block>[foo]</block>
    // - [<block>foo]</block>    ->    <block>[foo]</block>
    // - <block>f[oo</block>]    ->    <block>f[oo]</block>
    // - [<block>foo</block><selectable></selectable>]    ->    <block>[foo</block><selectable></selectable>]


    if (checkSelectionOnNonLimitElements(start, end, schema)) {
      var isStartBeforeSelectable = start.nodeAfter && schema.isSelectable(start.nodeAfter);
      var fixedStart = isStartBeforeSelectable ? null : schema.getNearestSelectionRange(start, 'forward');
      var isEndAfterSelectable = end.nodeBefore && schema.isSelectable(end.nodeBefore);
      var fixedEnd = isEndAfterSelectable ? null : schema.getNearestSelectionRange(end, 'backward'); // The schema.getNearestSelectionRange might return null - if that happens use original position.

      var rangeStart = fixedStart ? fixedStart.start : start;
      var rangeEnd = fixedEnd ? fixedEnd.end : end;
      return new Range(rangeStart, rangeEnd);
    }
  }

  var isStartInLimit = startLimitElement && !startLimitElement.is('rootElement');
  var isEndInLimit = endLimitElement && !endLimitElement.is('rootElement'); // At this point we eliminated valid positions on text nodes so if one of range positions is placed inside a limit element
  // then the range crossed limit element boundaries and needs to be fixed.

  if (isStartInLimit || isEndInLimit) {
    var bothInSameParent = start.nodeAfter && end.nodeBefore && start.nodeAfter.parent === end.nodeBefore.parent;
    var expandStart = isStartInLimit && (!bothInSameParent || !isSelectable(start.nodeAfter, schema));
    var expandEnd = isEndInLimit && (!bothInSameParent || !isSelectable(end.nodeBefore, schema)); // Although we've already found limit element on start/end positions we must find the outer-most limit element.
    // as limit elements might be nested directly inside (ie table > tableRow > tableCell).

    var _fixedStart = start;
    var _fixedEnd = end;

    if (expandStart) {
      _fixedStart = Position._createBefore(findOutermostLimitAncestor(startLimitElement, schema));
    }

    if (expandEnd) {
      _fixedEnd = Position._createAfter(findOutermostLimitAncestor(endLimitElement, schema));
    }

    return new Range(_fixedStart, _fixedEnd);
  } // Range was not fixed at this point so it is valid - ie it was placed around limit element already.


  return null;
} // Finds the outer-most ancestor.
//
// @param {module:engine/model/node~Node} startingNode
// @param {module:engine/model/schema~Schema} schema
// @param {String} expandToDirection Direction of expansion - either 'start' or 'end' of the range.
// @returns {module:engine/model/node~Node}


function findOutermostLimitAncestor(startingNode, schema) {
  var isLimitNode = startingNode;
  var parent = isLimitNode; // Find outer most isLimit block as such blocks might be nested (ie. in tables).

  while (schema.isLimit(parent) && parent.parent) {
    isLimitNode = parent;
    parent = parent.parent;
  }

  return isLimitNode;
} // Checks whether any of range boundaries is placed around non-limit elements.
//
// @param {module:engine/model/position~Position} start
// @param {module:engine/model/position~Position} end
// @param {module:engine/model/schema~Schema} schema
// @returns {Boolean}


function checkSelectionOnNonLimitElements(start, end, schema) {
  var startIsOnBlock = start.nodeAfter && !schema.isLimit(start.nodeAfter) || schema.checkChild(start, '$text');
  var endIsOnBlock = end.nodeBefore && !schema.isLimit(end.nodeBefore) || schema.checkChild(end, '$text'); // We should fix such selection when one of those nodes needs fixing.

  return startIsOnBlock || endIsOnBlock;
} // Returns a minimal non-intersecting array of ranges.
//
// @param {Array.<module:engine/model/range~Range>} ranges
// @returns {Array.<module:engine/model/range~Range>}


function mergeIntersectingRanges(ranges) {
  var nonIntersectingRanges = []; // First range will always be fine.

  nonIntersectingRanges.push(ranges.shift());

  var _iterator2 = _createForOfIteratorHelper(ranges),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var range = _step2.value;
      var previousRange = nonIntersectingRanges.pop();

      if (range.isEqual(previousRange)) {
        // Use only one of two identical ranges.
        nonIntersectingRanges.push(previousRange);
      } else if (range.isIntersecting(previousRange)) {
        // Get the sum of two ranges.
        var start = previousRange.start.isAfter(range.start) ? range.start : previousRange.start;
        var end = previousRange.end.isAfter(range.end) ? previousRange.end : range.end;
        var merged = new Range(start, end);
        nonIntersectingRanges.push(merged);
      } else {
        nonIntersectingRanges.push(previousRange);
        nonIntersectingRanges.push(range);
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return nonIntersectingRanges;
} // Checks if node exists and if it's a selectable.
//
// @param {module:engine/model/node~Node} node
// @param {module:engine/model/schema~Schema} schema
// @returns {Boolean}


function isSelectable(node, schema) {
  return node && schema.isSelectable(node);
}